"use client";

import { Consultation } from "@/app/_components/consultation-card";
import { Error } from "@/app/_components/error";
import { Loading } from "../loading";

import { useNotice } from "@/queries/use-notice";

import type { NoticeItem } from "../notice.types";

export const Dispositivos = ({ id, field, emptyElement }: NoticeItem) => {
  const { data, isPending, error, refetch } = useNotice({ id, field });

  if (isPending) return <Loading />;

  if (error) return <Error reset={refetch} />;

  const notice = data?.analise.data;

  if (!notice) {
    return (
      emptyElement ?? (
        <p className="text-center text-base text-muted-foreground w-4/6">
          A análise do edital provavelmente não está disponível. Se você tiver
          alguma dúvida, não hesite em entrar em contato conosco.
        </p>
      )
    );
  }

  return (
    <Consultation.Card
      title="Interpretação dos Dispositivos"
      description="Explicação das cláusulas e termos do edital"
    >
      <ul className="flex flex-col gap-6">
        {notice.pontos_a_interpretar.map((dispositivo, index) => (
          <li
            key={index}
            className="flex flex-col gap-2 border-b pb-3 last:border-0 last:pb-0"
          >
            <h2 className="font-medium">{dispositivo.titulo}</h2>
            <p className="text-muted-foreground">{dispositivo.descricao}</p>
          </li>
        ))}
      </ul>
    </Consultation.Card>
  );
};
